// Application form types based on IMPLEMENTATION_SPEC.md

export type RecipientType = "osbb" | "manager" | "cooperative";

export type AssistanceCategory = "category_a" | "category_b" | "category_c";

export type BoilerRoomType = "roof" | "attached" | "builtin" | null;

export const BOILER_ROOM_LABELS: Record<string, string> = {
  roof: "Дахова",
  attached: "Прибудована",
  builtin: "Вбудована",
};

export type EquipmentType =
  | "generator_petrol"
  | "generator_diesel"
  | "generator_gas"
  | "inverter"
  | "battery_controller"
  | "batteries"
  | "solar_panels";

export type DocumentType =
  | "doc_emergency_decision"
  | "doc_tech_passport"
  | "doc_floors_certificate"
  | "doc_edr_extract"
  | "doc_management_decision"
  | "doc_statute"
  | "doc_management_contract"
  | "doc_local_authority_letter";

export interface RecipientInfo {
  recipient_type: RecipientType | null;
  organization_name: string;
  edrpou_code: string;
  legal_address: string;
  actual_address: string;
  phone: string;
  email: string;
  iban: string;
  head_full_name: string;
}

export interface BuildingInfo {
  building_address: string;
  floors_count: number | null;
  co_owners_count: number | null;
  apartments_count: number | null;
  total_area: number | null;
  boiler_room_type: BoilerRoomType;
  has_tech_passport: boolean;
}

export interface EquipmentInfo {
  equipment_types: EquipmentType[];
  has_supply_contract: boolean;
  contract_number: string;
  contract_date: string;
  supplier_name: string;
  supplier_edrpou: string;
  equipment_description: string;
  equipment_cost: number | null;
  delivery_deadline: string;
}

export interface DocumentFile {
  id: string;
  type: DocumentType;
  file: File | null;
  name: string;
  uploaded: boolean;
}

export interface Obligations {
  // Single checkbox for all obligations
  obligations_accepted: boolean;
  // Consents for final step
  consent_data_processing: boolean;
  consent_terms: boolean;
}

export interface ApplicationFormData {
  recipient: RecipientInfo;
  building: BuildingInfo;
  equipment: EquipmentInfo;
  documents: DocumentFile[];
  obligations: Obligations;
}

export interface AssistanceCalculation {
  category: AssistanceCategory;
  amount: number;
  reason: string;
}

// Initial form state
export const initialRecipientInfo: RecipientInfo = {
  recipient_type: null,
  organization_name: "",
  edrpou_code: "",
  legal_address: "",
  actual_address: "",
  phone: "+380",
  email: "",
  iban: "",
  head_full_name: "",
};

export const initialBuildingInfo: BuildingInfo = {
  building_address: "",
  floors_count: null,
  co_owners_count: null,
  apartments_count: null,
  total_area: null,
  boiler_room_type: null,
  has_tech_passport: true,
};

export const initialEquipmentInfo: EquipmentInfo = {
  equipment_types: [],
  has_supply_contract: false,
  contract_number: "",
  contract_date: "",
  supplier_name: "",
  supplier_edrpou: "",
  equipment_description: "",
  equipment_cost: null,
  delivery_deadline: "",
};

export const initialObligations: Obligations = {
  obligations_accepted: true,
  consent_data_processing: true,
  consent_terms: true,
};

export const initialFormData: ApplicationFormData = {
  recipient: initialRecipientInfo,
  building: initialBuildingInfo,
  equipment: initialEquipmentInfo,
  documents: [],
  obligations: initialObligations,
};
